import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=c7befa48&scoped=true"
import script from "./ResultView.vue?vue&type=script&lang=js"
export * from "./ResultView.vue?vue&type=script&lang=js"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=c7befa48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7befa48",
  null
  
)

export default component.exports